import React from "react";
import { Box, Typography } from "@mui/material";
import MetricsCardsContainer from "./MetricsCardsContainer";

/**
 * Компонент сетки метрик.
 * Передаёт все данные карточкам: метрики, тренды, загрузку, ошибки.
 * Во время загрузки содержимое не прячется: карточки показывают скелетоны.
 */
const MetricsGrid = ({ filteredData, trends, loading, error, token }) => {
  return (
    <Box
      sx={{
        width: "100%",
        pt: 0,
        pb: 2,
        margin: "0 auto",
      }}
    >
      {error ? (
        <Typography
          sx={{
            color: "#ff6666",
            textAlign: "center",
            mt: 2,
            fontSize: "0.9rem",
          }}
        >
          {error}
        </Typography>
      ) : (
        <MetricsCardsContainer
          filteredData={filteredData}
          trends={trends}         // 🔹 передаём тренды
          loading={loading}
          token={token}
        />
      )}
    </Box>
  );
};

export default MetricsGrid;
